import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getTemporadasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`temp_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/temporadas", queryString);
};

export const getTemporadaById = async (id) => {
    const res = await getData(`/temporadas/${id}`)
    return res
}

export const postTemporada = async (body) => {
    const res = await postData('/temporadas', body)
    return res
}

export const patchTemporada = async (id, body) => {
    const res = await patchData(`/temporadas/${id}`, body)
    return res
}

export const deleteTemporada = async (id) => {
    const res = await deleteData(`/temporadas/${id}`)
    return res
}